import type { TeleconsultoriaActor, TeleconsultoriaAvailableProfessional } from "../../types";
import { practitionerKey } from "../../utils/actors";
import type { ProviderAgendaSlot } from "../services/providerAgendaService";

/** Teleconsultor da prestadora na marcação: horários no período e/ou disponível agora. */
export interface TeleconsultorChoice {
  /** CPF (une a mesma pessoa vinda da agenda e da disponibilidade). */
  key: string;
  teleconsultor: TeleconsultoriaActor;
  serviceName: string;
  /** Horários livres no período, em ordem. */
  slots: ProviderAgendaSlot[];
  /** Disponibilidade ligada: pode ser chamado "Agora" (se estiver online). */
  isAvailableNow: boolean;
}

/**
 * Junta horários (agendas) e disponibilidade numa lista só, um card por pessoa.
 * Ordem: disponíveis agora primeiro; depois por nome.
 */
export function buildTeleconsultorChoices(
  slots: ProviderAgendaSlot[],
  availableNow: TeleconsultoriaAvailableProfessional[],
): TeleconsultorChoice[] {
  const byKey = new Map<string, TeleconsultorChoice>();
  const choiceFor = (teleconsultor: TeleconsultoriaActor, serviceName: string) => {
    const key = practitionerKey(teleconsultor.reference);
    if (!key) return undefined;
    if (!byKey.has(key)) {
      byKey.set(key, { key, teleconsultor, serviceName, slots: [], isAvailableNow: false });
    }
    return byKey.get(key);
  };

  slots.forEach((slot) => {
    choiceFor(slot.agenda.teleconsultor, slot.serviceName)?.slots.push(slot);
  });
  availableNow.forEach((row) => {
    const choice = choiceFor(row.guest.practitioner, row.guest.healthcareService?.display || "");
    if (!choice) return;
    choice.isAvailableNow = true;
    // "Agora" usa a reference da disponibilidade (é a que o convite e a presença usam).
    choice.teleconsultor = row.guest.practitioner;
    choice.serviceName = choice.serviceName || row.guest.healthcareService?.display || "";
  });

  return [...byKey.values()].sort((first, second) => {
    if (first.isAvailableNow !== second.isAvailableNow) return first.isAvailableNow ? -1 : 1;
    return (first.teleconsultor.display || "").localeCompare(second.teleconsultor.display || "", "pt-BR");
  });
}
